export enum MetricEventType {
  CLICK_CSV_UPLOAD = "CLICK_CSV_UPLOAD",
  CLICK_CSV_DOWNLOAD = "CLICK_CSV_DOWNLOAD",
  CLICK_EXCEL_DOWNLOAD = "CLICK_EXCEL_DOWNLOAD",
  CLICK_ADD_SINGLE_ISIN = "CLICK_ADD_SINGLE_ISIN",
  CLICK_CALCULATE_PORTFOLIO_BUTTON = "CLICK_CALCULATE_PORTFOLIO_BUTTON",
  REMOVED_ISINS = "REMOVED_ISINS",
  PORTFOLIO_SIZE = "PORTFOLIO_SIZE",
}
